export const gDEConnectorStrs =
{
    "jobvitekey": "API-Schlüssel:",
    "bamboo3a": "Generieren Sie in Ihrem BambooHR-Profil",
    "jobvitesecret": "API-Geheimnis:",
    "odbcdsn2": "ODBC-DSN",
    "uf_usernotfound": "Aktueller Benutzer nicht in userfeed.txt gefunden",
    "sffieldmap2": "Komma-getrennte Liste der gewünschten Feldnamen",
    "ultiproloaderr4": "Es wurden keine Mitarbeiterdaten zurückgegeben.",
    "breathehrloaderr4": "Es wurden keine Mitarbeiterdaten zurückgegeben.",
    "jobvitedept": "Abteilung:",
    "bamboo2": "Subdomain",
    "payspacecerr2": "Das Passwort kann nicht leer sein.",
    "greenhousereportid2": "Geben Sie 0 für einfache, 1 für erweiterte",
    "sapcerr2": "Die Systemnummer kann nicht leer sein.",
    "salesforceloaderr3": "Keine Datensätze zurückgegeben.",
    "adpHR9": "Optimierter Server",
    "payspaceterm": "Laufzeit Monate:",
    "odbcserver": "Server:",
    "subscribeHRLink2": "Abonnieren-HR Firmenname",
    "sfsforg2": "SuccessFactors Organisationskodex",
    "subscribehrcerr2": "Die Benutzer-ID kann nicht leer sein.",
    "ultiprocerr9": "Der Berichtspfad kann nicht leer sein.",
    "sapobjectid2": "Objekt-ID eingeben",
    "sapcerr0": "Application Server kann nicht leer sein.",
    "ultiproReportPath2": "Nur für die BI-Schnittstelle (z.B.: Company_Acme_MyReports)",
    "adphrloaderr": "Abfrage fehlgeschlagen. Überprüfen Sie die Konfiguration des ADP-Connectors. Klicken Sie auf das '?' für Details zur Konfiguration des Konnektors.",
    "sapclient2": "Kundennummer eingeben",
    "signifycerr0": "Das Token kann nicht leer sein.",
    "googleConfig": "Konfigurieren der Google-Verzeichnisverbindung",
    "googleserv1": "Service-Konto-Anmeldeinformationen hochladen",
    "subscribeHRReport1": "Berichts-ID:",
    "jobvitecerr0": "Der API-Schlüssel kann nicht leer sein.",
    "icimscerr4": "Das Abteilungszeichen kann nicht leer sein.",
    "odbcuser2": "Benutzer-ID",
    "signifyconfig": "Signify-Verbindung konfigurieren",
    "sapobjecttype": "Objekttyp:",
    "greenhousecerr1": "Die Stellenbezeichnung kann nicht leer sein.",
    "googlecreduploadfail": "Upload fehlgeschlagen - kontaktieren Sie den Support.",
    "odbctable": "Tabelle/Ansicht:",
    "ultiproUser2": "UKG Pro-Benutzername",
    "ADPProf": "Profil:",
    "bamboo6a": "Bitte klicken Sie auf den '?' für weitere Informationen.",
    "breatheHR4a": "Geben Sie 0 für einfache, 1 für erweiterte",
    "icimsuser2": "Erhalten von Ihrem iCIMS-Integrationsspezialisten",
    "sapcerr6": "Die Objekt-ID kann nicht leer sein.",
    "sfquery2": "Salesforce SOQL-Abfrage",
    "sfsfresource": "Ressource-Tabelle",
    "sutihrloaderr2": "Schlechte Daten zurückgegeben. Prüfen Sie die Konfiguration des Steckers.",
    "icimsConfig": "Konfigurieren der iCIMS-Verbindung",
    "googledirloaderr": "Abfrage fehlgeschlagen. Überprüfen Sie die Konfiguration des Google Directory-Connectors.",
    "ultiprocerr8": "Der Berichtsname kann nicht leer sein.",
    "ultiproReport2": "Geben Sie 0 für einfache, 1 für erweiterte",
    "odbcreportid2": "Geben Sie 0 für Standard",
    "bamboo4": "Berichts-ID:",
    "triConfig": "TriNet-Verbindung konfigurieren",
    "sfuser2": "Salesforce-Benutzer-ID",
    "sapviewid2": "ViewID eingeben",
    "workdaycerr1": "Arbeitstag Benutzer kann nicht leer sein",
    "icimspwd": "Passwort:",
    "workdaymsg": "Bitte wenden Sie sich an den technischen Support, um Hilfe beim Extrahieren von Daten aus Ihrem Workday-Konto zu erhalten.",
    "orangepassword2": "OrangeHRM-Kennwort",
    "adpkey": "Schlüssel abrufen",
    "reportid2": "Geben Sie 0 für Standard ein",
    "greenhousetoken2": "In Ihrem Gewächshausprofil generieren",
    "subscribeHRConfig": "Subscribe-HR-Verbindung konfigurieren",
    "sutihrcerr5": "Die Berichts-ID kann nicht leer sein.",
    "greenhousedept": "Abteilung:",
    "adphrloaderr4": "Es wurden keine Mitarbeiterdaten zurückgegeben.",
    "payspacecerr5": "Die Berichts-ID kann nicht leer sein.",
    "sutirid1": "Berichts-ID:",
    "sfsfcerr2": "Das Passwort kann nicht leer sein.",
    "sappassword2": "SAP-Kennwort eingeben",
    "subscribeHRUser2": "Abonnieren-HR Benutzer-ID",
    "ultiproPass1": "Passwort:",
    "sapxmlConfig": "SAP-XML-Verbindung konfigurieren",
    "breatheHR3": "In breatheHR generieren",
    "bamboo3": "API-Schlüssel:",
    "Client ID:": "Kunden-ID:",
    "triclientsecret": "Kunden-Geheimnis:",
    "orangeuser": "Benutzer-ID:",
    "payspacepassword": "Passwort:",
    "workdayendpoint": "Workday-Endpunkt",
    "namelyreportid2": "Geben Sie 0 für Standard ein",
    "adpHR5": "Benutzerdefinierte Felder:",
    "googleloaderr": "Abfrage fehlgeschlagen. Überprüfen Sie die Konfiguration des Google-Connectors.",
    "sutihrloaderr3": "Es wurden keine Mitarbeiterdaten zurückgegeben.",
    "icimstitle2": "Berufstitel mapt zu?",
    "adphrcerr2": "Kunden-Geheimnis kann nicht leer sein.",
    "payspacereportid2": "Geben Sie 0 für einfache, 1 für erweiterte",
    "icimscusid2": "Ihre iCIMS-Kunden-ID",
    "jobviteloaderr": "Abfrage fehlgeschlagen. Überprüfen Sie die Jobvite-Konnektorkonfiguration.",
    "sfsfcerr3": "Der Org-Code kann nicht leer sein.",
    "namelycerr1": "Das API-Token kann nicht leer sein.",
    "ultiproLink2": "Von UKG Pro abrufen",
    "icimscerr0": "Der Benutzer kann nicht leer sein.",
    "ultiproReportName2": "Nur für die BI-Schnittstelle",
    "sfsfloaderr": "Abfrage fehlgeschlagen. Überprüfen Sie die SuccessFactors-Konnektorkonfiguration.",
    "jobvitecerr3": "Das Abteilungszeichen kann nicht leer sein.",
    "salesforcecerr2": "Das Passwort kann nicht leer sein.",
    "ultiproInterface2": "BI, BIT oder WS eingeben",
    "sfsandbox2": "für die Produktion leer lassen, für den Sandbox auf 'true' setzen",
    "uf_userexists_err": "Benutzereintrag, der von einem anderen Konto verwendet wird.",
    "naturalhrcerr2": "Die Berichts-ID kann nicht leer sein.",
    "sfuser": "Benutzer-ID",
    "subscribeHRUser1": "Benutzer-ID:",
    "orangereportid2": "Geben Sie 0 für einfache, 1 für erweiterte",
    "ultiproReportName1": "Name des Berichts:",
    "azureConfig": "AzureAD-Verbindung konfigurieren",
    "icimsdept": "Abteilung:",
    "peopleHR4": "Berichts-ID:",
    "adpkeyhelpmsg": "Klicken Sie auf den '?' für zusätzliche Hilfe.",
    "breathehrcerr2": "Die Berichts-ID kann nicht leer sein.",
    "saphost": "Anwendungsserver:",
    "jobvitecerr1": "API Gehemnis kann nicht leer sein.",
    "subscribeHRPass1": "Passwort:",
    "adpHR10a": "Leer lassen für Standardabfrage",
    "payspacecerr3": "Der Anfragetyp kann nicht leer sein.",
    "salesforceloaderr": "Abfrage fehlgeschlagen. Überprüfen Sie die Salesforce-Konnektorkonfiguration.",
    "odbcdriver": "Fahrer:",
    "sapobjecttype2": "Objekttyp eingeben",
    "tricerr1": "Die Benutzer-ID kann nicht leer sein.",
    "peopleHR1": "PeopleHR-Verbindung konfigurieren",
    "ultiprocerr3": "Der Kunde Access Key kann nicht leer sein.",
    "dynloaderr1": "Es werden keine Daten zurückgegeben. Wenden Sie sich an den technischen Support. Fehlercode DC01.",
    "workdaycerr2": "Das Passwort kann nicht leer sein.",
    "greenhousetoken": "API-Token:",
    "icimsdept2": "Abteilung mapt zu?",
    "adpHR6a": "Geben Sie 0 für einfache, 1 für erweiterte",
    "odbcuser": "Benutzer-ID:",
    "workdaycerr4": "Das ReportID-Token kann nicht leer sein.",
    "jobvitecerr4": "Die Berichts-ID kann nicht leer sein.",
    "bamboocerr1": "Subdomäne kann nicht leer sein.",
    "odbcserver2": "Server-Adresse",
    "orangeConfig": "OrangeHRM-Verbindung konfigurieren",
    "odbccerr4": "Das Passwort kann nicht leer sein.",
    "sfsfpassword": "Passwort",
    "salesforcecerr3": "Das Sicherheitstoken kann nicht leer sein.",
    "payspacereqtype": "Art der Anfrage:",
    "icimsuser": "Benutzer:",
    "orangecerr2": "Das Passwort kann nicht leer sein.",
    "sfsfadd": "Zusätzliche Felder:",
    "payspaceuser": "Benutzer-ID:",
    "namelytoken": "API-Token:",
    "bamboo4a": "Geben Sie 0 für einfache, 1 für erweiterte",
    "peoplehrloaderr4": "Es wurden keine Mitarbeiterdaten zurückgegeben.",
    "sapparams": "Zusätzliche Felder:",
    "namelytoken2": "Generieren Sie in Ihrem Namely-Profil",
    "googlecerr0": "Der Bereich kann nicht leer sein.",
    "namelyConfig": "Namely-Verbindung konfigurieren",
    "breathehrcerr1": "Der API-Schlüssel kann nicht leer sein.",
    "ultiprocerr2": "User Access Key kann nicht leer sein.",
    "tripassword": "Passwort:",
    "adpHR11": "Fotofeld einschließen",
    "orangesubdomain": "Unterdomäne:",
    "adphrcerr1": "Die Kunden-ID kann nicht leer sein.",
    "ultiproConfig": "UKG Pro-Verbindung konfigurieren",
    "sapxmlfields": "Zusätzliche Felder:",
    "activedirConfig": "Konfigurieren der Active Directory-Verbindung",
    "ultiproloaderr2": "Authentifizierung fehlgeschlagen. Überprüfen Sie die Konfiguration des UKG Pro Connector.",
    "sfsfservice2": "SuccessFactors Server-Adresse (Beispiel: api4)",
    "sapparams2": "Zusätzliche abzufragende Felder eingeben",
    "ultiquery": "Bericht als Abfrage ausführen",
    "jobvitecerr2": "Die Stellenbezeichnung kann nicht leer sein.",
    "bamboo5": "Gekündigte Mitarbeiter einbeziehen",
    "salesforcecerr1": "Die Benutzer-ID kann nicht leer sein.",
    "sfsforg": "Org-Code",
    "sapviewid": "ViewID:",
    "odbccerr5": "Der Name der Tabelle/Ansicht kann nicht leer sein.",
    "subscribehrloaderr4": "Es wurden keine Mitarbeiterdaten zurückgegeben.",
    "sfsfpassword2": "SuccessFactors-Passwort",
    "namelysubdomain2": "subdomain.namely.com",
    "adphrloaderr5": "ADP-Schnittstellenfehler:",
    "sfsfquerystring": "Abfrage-Parameter",
    "Client Secret:": "Kundengeheimnis:",
    "naturalhrConfig": "NaturalHR-Verbindung konfigurieren",
    "orangesubdomain2": "subdomain.orangehrm.com",
    "salesforcecerr4": "Sandbox-Wert ungültig.",
    "namelysubdomain": "Unterdomäne:",
    "jobviteConfig": "Jobvite-Verbindung konfigurieren",
    "bamboocerr3": "Der API-Schlüssel muss genau 40 Zeichen lang sein.",
    "sapuser": "SAP-Benutzer:",
    "triclientsecret2": "TriNet-Kunden Geheimnis",
    "salesforceConfig": "Salesforce-Verbindung konfigurieren",
    "upuseraccesskey2": "Von UKG Pro abrufen",
    "bambookey": "API-Schlüssel abrufen",
    "activedirmsg": "Um Daten aus dem Active Directory zu extrahieren, muss ein kleines Softwarepaket auf einem Server in Ihrem Netzwerk installiert werden. Klicken Sie auf den '?' für weitere Informationen.",
    "payspaceterm2": "Geben Sie 0 ein, um gekündigte Mitarbeiter auszuschließen",
    "workdaypassword": "API-Kennwort",
    "greenhousecerr2": "E-Mail kann nicht leer sein.",
    "payspaceloaderr": "Abfrage fehlgeschlagen. Prüfen Sie die Konfiguration des Konnektors.",
    "workdayendpoint2": "Der Endpunkt des von Ihnen generierten RaaS",
    "odbccerr2": "Server kann nicht leer sein.",
    "jobvitetitle2": "Berufstitel mapt zu?",
    "sutiuser2": "Benutzer-ID",
    "greenhouseemail": "E-Mail:",
    "triuser": "Benutzer-ID:",
    "googleemail": "E-Mail:",
    "QATS": "Greenhouse-ATS-Daten anhängen",
    "icimscerr5": "Die Berichts-ID kann nicht leer sein.",
    "suticonfig": "SutiHR-Verbindung konfigurieren",
    "ultiproloaderr3": "Schlechte Daten zurückgegeben. Prüfen Sie die Konfiguration des UKG Pro-Steckers.",
    "authsuccess": "Authentifizierungsprüfung: Erfolg",
    "odbctable2": "Geben Sie den Tabellen- oder Ansichtsnamen ein",
    "greenhouseConfig": "Gewächshausverbindung konfigurieren",
    "breatheHR4": "Alle Felder abfragen",
    "tricerr2": "Das Passwort kann nicht leer sein.",
    "sfsfreportid2": "Geben Sie 0 für einfache, 1 für erweiterte",
    "tripassword2": "TriNet-Kennwort",
    "sutihrcerr3": "Der Benutzername kann nicht leer sein.",
    "ultiproReportPath1": "Pfad berichten:",
    "peopleHR2": "API-Schlüssel",
    "adphrloaderr3": "Schlechte Daten zurückgegeben. Überprüfen Sie die Konfiguration des ADP-Verbinders.",
    "workdayConfig": "Arbeitstag-Verbindung konfigurieren",
    "bamboocerr2": "Die Berichts-ID kann nicht leer sein.",
    "adphrloaderr2": "Die Authentifizierung ist fehlgeschlagen. Überprüfen Sie die Konfiguration des ADP-Connectors.",
    "sutiapi2": "In SutiHR generieren",
    "adphrcerr3": "Die Berichts-ID kann nicht leer sein.",
    "ultiprocerr5": "Das Passwort kann nicht leer sein.",
    "namelycerr0": "Subdomäne kann nicht leer sein.",
    "payspaceoptions": "Optionen:",
    "payspacereportid": "Berichts-ID:",
    "sfpassword2": "Salesforce-Kennwort",
    "greenhousecerr0": "Das API-Token kann nicht leer sein.",
    "payspacecerr0": "Der Buchungskreis kann nicht leer sein.",
    "sfpassword": "Passwort",
    "uf_filenotfound_err": "Userfeed-Datei kann nicht gefunden oder geladen werden",
    "bamboo1": "BambooHR-Verbindung konfigurieren",
    "bamboo6": "Benutzerdefinierte Felder:",
    "sappassword": "SAP-Kennwort:",
    "breatheHR2": "API-Schlüssel",
    "adpHR5a": "Klicken Sie auf das ? für weitere Informationen",
    "adpHR1": "Konfigurieren der ADP-Verbindung",
    "odbcreportid": "Berichts-ID:",
    "orangeloaderr": "Abfrage fehlgeschlagen. Überprüfen Sie die Konfiguration des OrangeHRM-Verbinders.",
    "subscribehrloaderr2": "Die Authentifizierung ist fehlgeschlagen. Prüfen Sie die Konfiguration des Subscribe-HR-Konnektors.",
    "sapsystem": "Systemnummer:",
    "breathehrloaderr": "Abfrage fehlgeschlagen. Überprüfen Sie die Konfiguration des breatheHR-Verbinders.",
    "payspacecerr1": "Die Benutzer-ID kann nicht leer sein.",
    "adpkeyfail_keyretrieve": "Interner Fehler - Schlüssel nicht abrufbar. Wenden Sie sich an den technischen Support.",
    "peoplehrcerr2": "Die Berichts-ID kann nicht leer sein.",
    "greenhouseemail2": "Karten per E-Mail an?",
    "naturalhrtoken2": "Generieren Sie in Ihrem NaturalHR-Profil",
    "dynloaderr3": "Abfrage fehlgeschlagen. Wenden Sie sich an den technischen Support. Fehlercode DC03.",
    "odbccerr1": "DSN kann nicht leer sein.",
    "azuremsg": "Bitte wenden Sie sich an den technischen Support, um Hilfe beim Extrahieren von Daten aus Ihrer AzureAD-Instanz zu erhalten.",
    "adpkeyfail_auth": "Interner Fehler. Vertragliche technische Unterstützung.",
    "sfsfuser": "Benutzer-ID",
    "naturalhrloaderr": "Abfrage fehlgeschlagen. Überprüfen Sie die Konfiguration des NaturalHR-Steckers.",
    "adpHR6": "Berichts-ID:",
    "sffieldmap": "Feldkarte",
    "sfsandbox": "Sandbox",
    "peoplehrcerr1": "Der API-Schlüssel kann nicht leer sein.",
    "icimscerr3": "Die Stellenbezeichnung kann nicht leer sein.",
    "namelycerr2": "Die Berichts-ID kann nicht leer sein.",
    "adpkeyfail_nooid": "Fehlende OrganizationID. Sie müssen sich auf dem ADP-Marktplatz anmelden, um Schlüssel abzurufen.",
    "jobvitesecret2": "Generieren Sie in Ihrem Jobvite-Profil",
    "customConfig": "Konfigurieren einer benutzerdefinierten Verbindung",
    "payspacecompanycode": "Buchungskreis:",
    "sfsfcerr1": "Die Benutzer-ID kann nicht leer sein.",
    "jobvitekey2": "Generieren Sie in Ihrem Jobvite-Profil",
    "adpHR2a": "Klicken Sie auf die Schaltfläche Retrieve Keys",
    "sutihrcerr1": "Subdomäne kann nicht leer sein.",
    "greenhousedept2": "Abteilung mapt zu?",
    "sapcerr7": "Der Objekttyp kann nicht leer sein.",
    "naturalhrcerr1": "Das API-Token kann nicht leer sein.",
    "uf_invaliduser": "Ungültiger Benutzer oder E-Mail in userfeed.txt gefunden",
    "custommsg": "Bitte wenden Sie sich an den technischen Support, um Hilfe beim Extrahieren von Daten aus Ihrer benutzerdefinierten Instanz zu erhalten.",
    "icimscerr1": "Das Passwort kann nicht leer sein.",
    "breathehrloaderr3": "Schlechte Daten zurückgegeben. Überprüfen Sie die breatheHR-Konnektor-Konfiguration.",
    "upclientaccesskey2": "Abrufen von UKG Pro",
    "odbcdatabase": "Datenbank:",
    "peopleHR4a": "Geben Sie 0 für einfache, 1 für erweiterte",
    "sutiapi1": "API-Schlüssel:",
    "tricerr3": "Die Kunden-ID kann nicht leer sein.",
    "odbcloaderr": "Abfrage fehlgeschlagen. Überprüfen Sie die ODBC-Konfiguration.",
    "naturalhrtoken": "API-Token:",
    "sapobjectid": "Objekt-ID:",
    "googleDomain": "Domänenname:",
    "googlecredupload": "Berechtigungsnachweise hochgeladen.",
    "reportID": "Berichts-ID:",
    "payspaceuser2": "Benutzer-ID",
    "adpHR8": "Benutzerdefinierte Felder einschließen",
    "workdayapiuser2": "Der Benutzer hat die Erlaubnis zum Zugriff auf Workday",
    "adpHR4": "Klicken Sie auf die Schaltfläche Retrieve Keys",
    "jobvitetitle": "Stellenbezeichnung:",
    "orangecerr0": "Subdomäne kann nicht leer sein.",
    "odbccerr6": "Die Berichts-ID kann nicht leer sein.",
    "adpkeymsg": "ADP-Schlüssel abgerufen! Sie können jetzt den Import-Assistenten verwenden, um automatisch Organigramme mit Ihren ADP-Daten zu erstellen.",
    "bambooloaderr": "Abfrage fehlgeschlagen. Überprüfen Sie die Konfiguration des BambooHR-Steckers.",
    "greenhousetitle": "Stellenbezeichnung:",
    "subscribeHRReport2": "Geben Sie 0 für einfache, 1 für erweiterte",
    "sfsfuser2": "SuccessFactors-Benutzer-ID",
    "ultiprocerr7": "Die Schnittstelle muss auf BI, BIT oder WS eingestellt sein.",
    "sapuser2": "SAP-Benutzername eingeben",
    "sutihrloaderr": "Abfrage fehlgeschlagen. Prüfen Sie die Konfiguration des SutiHR-Steckers.",
    "tricerr5": "Die Berichts-ID kann nicht leer sein.",
    "payspaceConfig": "Cloud-Verbindung konfigurieren",
    "sutipw": "Passwort:",
    "odbcConfig": "Konfigurieren der ODBC-Verbindung",
    "googleDomain2": "mycompany.com",
    "odbccerr3": "Der Benutzername kann nicht leer sein.",
    "sfsfConfig": "SuccessFactors-Verbindung konfigurieren",
    "tricerr4": "Kunden-Geheimnis kann nicht leer sein.",
    "sapcerr4": "Das SAP-Kennwort kann nicht leer sein.",
    "notSandbox": "Dies ist kein Sandbox-Konto",
    "peoplehrloaderr3": "Schlechte Daten zurückgegeben. Überprüfen Sie die PeopleHR-Konnektor-Konfiguration.",
    "odbcpw": "Passwort:",
    "workdaypassword2": "Das API-Benutzer-Passwort",
    "workdayapiuser": "API-Benutzer",
    "signifytoken2": "Das API-Token, das in Signify",
    "greenhouseloaderr": "Abfrage fehlgeschlagen. Prüfen Sie die Konfiguration des Greenhouse-Steckers.",
    "greenhousev1label": "Legacy-v1-API verwenden (API Key)",
    "greenhouseconnect": "Mit Greenhouse verbinden",
    "greenhousereconnect": "Erneut mit Greenhouse verbinden",
    "greenhouseadminreq": "Melden Sie sich als Greenhouse-Site-Administrator an, um zu autorisieren.",
    "greenhouseautherr": "Greenhouse-Autorisierung fehlgeschlagen. Versuchen Sie erneut, eine Verbindung herzustellen.",
    "uf_usertype_err": "Ungültiger Benutzertyp in userfeed.txt",
    "subscribehrloaderr3": "Schlechte Daten zurückgegeben. Prüfen Sie die Konfiguration des Subscribe-HR-Konnektors.",
    "sfsfcerr4": "Die Berichts-ID kann nicht leer sein.",
    "sutihrcerr2": "Der API-Schlüssel kann nicht leer sein.",
    "icimstitle": "Stellenbezeichnung:",
    "orangecerr1": "Die Benutzer-ID kann nicht leer sein.",
    "odbcdatabase2": "Datenbankname (optional)",
    "customloaderr": "Benutzerdefinierte Abfrage fehlgeschlagen.",
    "sapcerr3": "SAP-Benutzer kann nicht leer sein.",
    "adphrloaderr6": "Nicht spezifizierter Fehler",
    "namelyloaderr": "Abfrage fehlgeschlagen. Prüfen Sie die Konfiguration des Namely-Konnektors.",
    "subscribehrloaderr": "Abfrage fehlgeschlagen. Prüfen Sie die Konfiguration des Subscribe-HR-Konnektors.",
    "ultiproInterface1": "Schnittstelle",
    "triclientid2": "TriNet-Kunden-ID",
    "ultiprocerr4": "Der Benutzername kann nicht leer sein.",
    "authfailure": "Authentifizierungsprüfung: Fehlschlag",
    "salesforceloaderr2": "Schlechte Daten zurückgegeben. Prüfen Sie die Konfiguration des Steckers.",
    "sfsfreportid": "Berichts-ID:",
    "ultiproReport1": "Berichts-ID:",
    "orangecerr3": "Die Berichts-ID kann nicht leer sein.",
    "ultiprocerr6": "Die Berichts-ID kann nicht leer sein.",
    "sutihrcerr4": "Das Passwort kann nicht leer sein.",
    "triuser2": "TriNet-Benutzer-ID",
    "subscribehrcerr4": "Die Berichts-ID kann nicht leer sein.",
    "sfsfcerr0": "Die Serveradresse kann nicht leer sein.",
    "sutirid2": "Geben Sie 0 für einfache, 1 für erweiterte",
    "jobvitedept2": "Abteilung Karten zu?",
    "upclientaccesskey1": "Client-Zugangsschlüssel",
    "ultiproloaderr": "Abfrage fehlgeschlagen. Überprüfen Sie die Konfiguration des UKG Pro-Anschlusses.",
    "dynloaderr2": "Es werden keine Daten zurückgegeben. Wenden Sie sich an den technischen Support. Fehlercode DC02.",
    "adpHR7": "Schnittstelle:",
    "greenhousecerr4": "Die Berichts-ID kann nicht leer sein.",
    "trireportid2": "Geben Sie 0 für einfache, 1 für erweiterte",
    "salesforcecerr6": "Die Feldzuordnung kann nicht leer sein.",
    "orangeuser2": "OrangeHRM-Benutzer-ID",
    "sfsfservice": "Server",
    "breatheHR1": "breatheHR-Verbindung konfigurieren",
    "sutisub1": "Unterdomäne:",
    "triclientid": "Kunden-ID:",
    "ultiprocerr1": "Der Server-Link kann nicht leer sein.",
    "sftoken2": "Salesforce-Sicherheitstoken",
    "adpprofile": "Profil speichern",
    "sfquery": "Abfrage",
    "peopleHR3": "In PeopleHR generieren",
    "greenhousetitle2": "Jobtitel mapt zu?",
    "odbcdsn": "DSN:",
    "peoplehrloaderr2": "Die Authentifizierung ist fehlgeschlagen. Überprüfen Sie die PeopleHR-Konnektor-Konfiguration.",
    "icimscerr2": "Kunden-ID kann nicht leer sein",
    "uf_badgroup_err": "Ungültige Zugangsgruppe",
    "orangepassword": "Passwort:",
    "saphost2": "Host-Adresse eingeben",
    "googlecerr3": "Die Berichts-ID kann nicht leer sein.",
    "sapclient": "Kunde:",
    "ultiproLink1": "Server",
    "sapcerr5": "ViewID kann nicht leer sein.",
    "payspacereqtype2": "EmpDir, JobDir oder benutzerdefinierter Typ",
    "sutiuserl": "SutiHR Benutzer:",
    "sftoken": "Sicherheits-Token",
    "subscribehrcerr3": "Das Passwort kann nicht leer sein.",
    "sapcerr1": "Die Kundennummer kann nicht leer sein.",
    "workdaycerr0": "API-Benutzer kann nicht leer sein.",
    "trireportid": "Berichts-ID:",
    "adpHR10": "Abfrage",
    "ultiproUser1": "Benutzername:",
    "ATSType": "ATS:",
    "googleemail2": "Autorisiertes E-Mail-Konto",
    "sapConfig": "SAP-RFC-Verbindung konfigurieren",
    "sapxmlfields2": "Zusätzliche abzufragende Felder eingeben",
    "googlereportid2": "Geben Sie 0 für einfache, 1 für erweiterte",
    "salesforcecerr5": "Die Abfrage kann nicht leer sein.",
    "saploaderr": "Abfrage fehlgeschlagen. Prüfen Sie die SAP-Konnektorkonfiguration.",
    "icimscusid": "Kunden-ID:",
    "breathehrloaderr2": "Die Authentifizierung ist fehlgeschlagen. Überprüfen Sie die Konfiguration des breatheHR-Konnektors.",
    "odbcdriver2": "Treibername eingeben (optional)",
    "upuseraccesskey1": "Benutzer Zugriffsschlüssel",
    "payspacecompanycode2": "Buchungskreis eingeben",
    "payspacepassword2": "Kennwort",
    "googlereportid": "Berichts-ID:",
    "tricompany2": "Name des Unternehmens",
    "icimspwd2": "Erhalten von Ihrem iCIMS-Integrationsspezialisten",
    "sfsfadd2": "Geben Sie zusätzliche Felder an, die der Abfrage hinzugefügt werden sollen",
    "greenhousecerr3": "Das Abteilungszeichen kann nicht leer sein.",
    "payspacecerr4": "Kündigungsmonate können nicht leer sein.",
    "peoplehrloaderr": "Abfrage fehlgeschlagen. Überprüfen Sie die PeopleHR-Konnektor-Konfiguration.",
    "triloaderr": "Abfrage fehlgeschlagen. Überprüfen Sie die Konfiguration des TriNet-Steckers.",
    "sapsystem2": "Systemnummer eingeben",
    "sfsfquerystring2": "Parameter für Abfrage",
    "Email Field": "E-Mail-Feld",
    "Hiring Manager": "Einstellungsmanager",
    "genericapisecret1": "API-Geheimnis",
    "genericapikey1": "API-Schlüssel",
    "peopleHR7": "Abfrage verwenden",
    "genericloaderr": "Abfrage fehlgeschlagen. Überprüfen Sie die Konfiguration des Connectors.",
    "genericcompanyid1": "Firmen-ID",
    "genericapisecret2": "API-Geheimnis eingeben",
    "levertoken": "API-Token:",
    "genericadditionaltables": "Zusätzliche Tabellen",
    "sftpport2": "Wenn leer, ist der Standardwert 22",
    "sftpport1": "Anschluss",
    "sftpusername1": "Benutzername",
    "genericclientid1": "Client-Kennung",
    "sftpdirectory2": "Bsp: Unterverzeichnis1/Unterverzeichnis 2/Unterverzeichnis3",
    "clearcompanypassword2": "Geben Sie das Passwort für ClearCompany ATS ein.",
    "leverreqs": "Alle Suchaufträge",
    "genericpassword2": "API-Passwort eingeben",
    "Leave blank to match subdomain": "Leer lassen, um mit der Subdomain übereinzustimmen",
    "genericusername1": "Benutzername",
    "genericclientid2": "API-Client-ID eingeben",
    "genericpassword1": "Kennwort",
    "Inactive Statuses": "Inaktive Zustände",
    "genericclientsecret1": "Client-Geheimnis",
    "genericusername2": "API-Benutzername eingeben",
    "genericsubdomain2": "API-Subdomain eingeben",
    "genericcompanyid2": "API-Firmen-ID eingeben",
    "sftpfilename2": "Bsp: Testdatei.xls",
    "clearcompanyusername2": "Benutzernamen für ClearCompany ATS eingeben.",
    "sftppassword1": "Kennwort",
    "peopleHR6": "Name der in PeopleHR durchgeführten Abfrage eingeben",
    "genericapikey2": "API-Schlüssel eingeben",
    "peopleHR5": "Abfrage-Name",
    "sftppassword2": "Kennwort für Ihr SFTP-Konto.",
    "sftpusername2": "Bsp: example_ex",
    "sftpfilename1": "Dateiname",
    "genericqueryparams": "Abfrage-Parameter",
    "Custom Search": "Benutzerdefinierte Suche",
    "breatheHR5": "Vergangene Mitarbeiter",
    "genericclientsecret2": "API-Client-Geheimnis eingeben",
    "genericclientkey1": "Client-Schlüssel",
    "levertoken2": "Erzeugen Sie in Ihrem Lever-Profil",
    "Photo URL": "Foto-URL",
    "sftphost2": "Bsp: sftp://beispiel.orgchartnow.de",
    "sftpdirectory1": "Pfad zur Quelle",
    "sftphost1": "Host",
    "genericsubdomain1": "Unterdomäne",
    "genericclientkey2": "API-Client-Schlüssel eingeben",
    "Separate Job Reqs": "Separate Boxen für jedes offene Stellenangebot",
    "Req Count Field1": "Angebotsanzahlfeld",
    "Req Count Field2": "Geben Sie das Feld für die Angebotsanzahl aus den ATS-Daten ein",
    "genericresource2": "Ressource eingeben",
    "genericresource1": "Ressource",
    "generictenantid2": "Konto-ID eingeben",
    "genericcompany2": "Unternehmen darf nicht leer sein",
    "genericapppass2": "Anwendungspasswort eingeben",
    "genericappid1": "App-ID",
    "genericsite1": "Webseite",
    "genericappid2": "Anwendungs-ID eingeben",
    "genericdomain2": "Domäne eingeben",
    "genericcompany1": "Gesellschaft",
    "generictable": "Tabelle",
    "genericdomain1": "Domäne",
    "generictenantid1": "Konto-ID",
    "genericcommunity2": "Gemeinschaft betreten",
    "genericcommunity1": "Gemeinschaft",
    "genericapppass1": "App-Passwort",
    "genericsite2": "Webseite betreten",
    "genericendpoint1": "API-Endpunkt",
    "genericendpoint2": "API-Endpunkt eingeben",
    "generictoken1": "API-Token",
    "dfstatus1": "Aktive Stati",
    "genericusetable": "Tabelle verwenden",
    "generictoken2": "API-Token eingeben",
    "genericport1": "Port-Nummer",
    "genericport2": "Portnummer eingeben",
    "dfstatus2": "Aktive Status Codes (optional)",
    "dfidprefix": "Präfix für Mitarbeiter-ID",
    "dfidprefixhelper": "Wird den Mitarbeiter- und Vorgesetzten-IDs aus dieser Quelle hinzugefügt. Verwenden Sie es, wenn zwei Dayforce-Umgebungen dieselben Mitarbeiternummern verwenden.",
    "payspacetogglerest": "REST API verwenden",
    "sageauthmethodtoggle": "Authentifizierung mit Benutzername und Passwort verwenden",
    "ATS": "ATS",
    "genericrefreshtoken2": "API-Aktualisierungs-Token eingeben",
    "genericaccountname1": "Kontoname",
    "genericadditionalfields1": "Zusätzliche Felder",
    "Child resources helper": "workRelationships.assignments, Namen",
    "genericaccountname2": "Kontoname eingeben",
    "genericrefreshtoken1": "Token aktualisieren",
    "peopleHR8": "Alle Felder abfragen (einschließlich sensibler Daten)",
    "Finder helper": "Abfrage mit vordefiniertem Finder (z.B. 'findByPersonId')",
    "limitlabel": "Datensätze pro Anfrage",
    "limithelper": "Anzahl der Datensätze, die pro API-Aufruf abgerufen werden (Standard 250, maximal 500)",
    "genericadditionalfields2": "Zusätzliche Felder eingeben",
    "bambootogglelegacy": "(Legacy-)API-Schlüssel verwenden",
    "Parameters": "Parameter",
    "Custom Base Profile": "Benutzerdefiniertes Basisprofil",
    "Parameters helper": "Abfrageparameter (z.B. 'workRelationships.TerminationDate ist null')",
    "genericclientcode1": "Kunden-Code",
    "genericfilter2": "Filter eingeben",
    "genericfilter1": "Filter",
    "genericclientcode2": "Kunden-Code eingeben",
    "genericschemaid1": "Schema-ID",
    "genericschemaid2": "Schema-ID eingeben",
    "Child resources": "Untergeordnete Ressourcen",
    "adpoid": "ADP OID",
    "Finder": "Finder",
    "genericstatus1": "Status",
    "paycorsubkey1": "Abonnementschlüssel",
    "paycorsubkey2": "Paycor-Abonnementschlüssel eingeben",
    "paycorlegentityid1": "ID der juristischen Person",
    "paycorlegentityid2": "Paycor-ID der juristischen Person eingeben",
    "othLoginUrl": "eywpLoginUrl",
    "PaycomIP": "Kontaktieren Sie Ihren Paycom-Administrator, um die folgende IP-Adresse freizugeben",
    "PaycomHelp": "Paycom erfordert die Freigabe aller IP-Adressen, über die Sie auf die API zugreifen möchten",
    "Source ID": "Quell-ID",
    "Generating...": "Wird generiert...",
    "Loading...": "Wird geladen...",
    "Loading existing key...": "Vorhandener Schlüssel wird geladen...",
    "Regenerate API Key": "API-Schlüssel neu generieren",
    "Generate API Key": "API-Schlüssel generieren",
    "API key configured": "API-Schlüssel konfiguriert",
    "No API key generated": "Kein API-Schlüssel generiert",
    "API key generated successfully": "API-Schlüssel erfolgreich generiert",
    "Failed to generate API key": "API-Schlüssel konnte nicht generiert werden",
    "View or regenerate the API key used for this integration. If you regenerate the key, remember to update it in your external application to maintain connectivity. ": "Zeigen Sie den für diese Integration verwendeten API-Schlüssel an oder generieren Sie ihn neu. Wenn Sie den Schlüssel neu generieren, aktualisieren Sie ihn in Ihrer externen Anwendung, um die Konnektivität aufrechtzuerhalten. {linkText}",
    "Click here to find documentation.": "Klicken Sie hier, um die Dokumentation aufzurufen.",
    "An error occurred. Please try again.": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    "resourceId": "Ressourcen-ID",
    "resourceId2": "Azure AD-Ressourcen-ID eingeben"
}
